import { createFileRoute, useNavigate } from '@tanstack/react-router'

import {
    GRADE_CATALOG_FILTERS,
    GradeCatalogPage,
} from '@/components/tea-grades/grade-catalog-page'

export const Route = createFileRoute(
    '/_app/_authed/_sidebar/sorting-warehouse/tea-grades',
)({
    validateSearch: GRADE_CATALOG_FILTERS.validateSearch,
    component: TeaGradesPage,
})

// Export named để test render được màn thật: autoCodeSplitting tách `component`
// khỏi route nên `Route.options.component` chỉ còn là stub rỗng.
export function TeaGradesPage() {
    const navigate = useNavigate({ from: '/sorting-warehouse/tea-grades' })
    return (
        <GradeCatalogPage
            kind="sorting"
            search={Route.useSearch()}
            onSearchChange={(next, opts) =>
                void navigate({
                    search: () => next,
                    replace: opts?.replace ?? false,
                })
            }
        />
    )
}
